import "./styles.scss";

import { createApp, h } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import BookingDashboard from "./BookingDashboard.vue";
import BookingActionsProvider from "../providers/BookingActionsProvider.vue";
import { createBootstrap } from "bootstrap-vue-next";
import { roomBookingQueryClient, initUrlConfig } from "../api";
import VueMultiselect from 'vue-multiselect';

$(document).ready(function () {
	// Check if we're on the admin frontend page
	if (!/\/room-booking\/dashboard$/.test(window.location.pathname)) {
		return;
	}

	const container = $("#vue-container");
	if (!container.length) {
		console.error("Room booking calendar container not found");
		return;
	}

	// Admin frontend configuration
	const config = {
		roomBookingApiUrl: container.data("roomBookingApiUrl"),
		userApiUrl: container.data("userApiUrl"),
		helpUrl: container.data("helpUrl"),
		userRole: container.data("userRole"),
	};

	// Validate required data
	if (!config.roomBookingApiUrl || !config.userApiUrl) {
		console.error("Missing required configuration for admin frontend");
		return;
	}

	// Initialize URL configuration FIRST
	initUrlConfig({
		userApiUrl: config.userApiUrl,
		roomBookingApiUrl: config.roomBookingApiUrl,
		helpUrl: config.helpUrl,
	});

	// Wrap BookingDashboard with BookingActionsProvider using render function
	const app = createApp(
		{
			render() {
				return h(BookingActionsProvider, null, {
					default: () =>
						h(BookingDashboard, {
							roomBookingApiUrl: this.roomBookingApiUrl,
							userApiUrl: this.userApiUrl,
							helpUrl: this.helpUrl,
							userRole: this.userRole,
						}),
				});
			},
			props: ["roomBookingApiUrl", "userApiUrl", "helpUrl", "userRole"],
		},
		config
	);

	// Setup TanStack Query
	app.use(VueQueryPlugin, {
		queryClient: roomBookingQueryClient,
	});

	// Setup Bootstrap
	app.use(createBootstrap());

	// Register vue-multiselect component
	app.component('VMultiselect', VueMultiselect);

	// Mount the app
	app.mount(container[0]);
});
